import { safeJsonParse } from "@/lib/safeJsonParse";
import { cn } from "@/lib/utils";
import { ArrowUpRight, MapPin } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import GoogleMap from "google-maps-react-markers";
import { CircleIcon } from "lucide-react";

export default function EventLocation({
  event,
  className,
  withMap = false,
}: any) {
  const t = useTranslations("General");

  const AnyReactComponent = ({ text }: any) => (
    <div
      style={{
        position: "absolute",
      }}
    >
      <CircleIcon className="absolute w-4 h-4 opacity-50 fill-green-500 stroke-none animate-ping " />
      <CircleIcon className="absolute w-4 h-4 fill-green-500 stroke-none " />
    </div>
  );

  return (
    <div
      className={cn(
        className,
        "flex flex-col hover:bg-primary/5 p-2 -mx-2 rounded-xl cursor-pointer",
      )}
    >
      <Link
        className="flex flex-row"
        target="_blank"
        href={`https://www.google.com/maps/dir/?api=1&destination=${safeJsonParse(event.venue)?.formatted_address}`}
      >
        <div className="flex items-center w-14">
          <div className="flex items-center justify-center w-10 h-10 overflow-hidden capitalize border rounded-lg opacity-100 border-primary/10">
            {event.hiddenVenue ? <>👻</> : <MapPin className="opacity-50" />}
          </div>
        </div>
        <div>
          <div className="flex flex-col">
            <div className="flex items-start w-full h-6 max-w-[70vw] overflow-hidden font-medium capitalize truncate sm:max-w-none whitespace-nowrap">
              {event.hiddenVenue && (
                <div className="text-medium">{t("secret-location")}</div>
              )}
              {!event.hiddenVenue && (
                <>
                  {safeJsonParse(event.venue)?.name ||
                    t("somewhere-probably-on-earth")}{" "}
                  <ArrowUpRight className="h-4 opacity-50" />
                </>
              )}
            </div>

            <p className="max-w-[70vw] text-sm capitalize truncate sm:max-w-none text-muted-foreground dark:text-accent-foreground/50 overflow-ellipsis">
              {(!event.hiddenVenue &&
                safeJsonParse(event.venue)?.formatted_address) ||
                t("somewhere-probably-on-earth")}{" "}
            </p>
          </div>
        </div>
      </Link>

      {withMap && safeJsonParse(event.venue)?.formatted_address && (
        <div className="p-1">
          <div
            className="mt-2 w-5/5 rounded-xl"
            style={{
              height: "300px",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <GoogleMap
              apiKey={process.env.GOOGLE_MAPS_API_KEY}
              defaultZoom={10}
              options={{
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                mapTypeControl: false,
                panControl: false,
                fullscreenControl: false,
                zoomControl: false,
                gestureHandling: "greedy",
              }}
              defaultCenter={{
                lat: safeJsonParse(event.venue)?.latitude || 36.8065,
                lng: safeJsonParse(event.venue)?.longitude || 10.1815,
              }}
              key={safeJsonParse(event.venue)?.formatted_address}
            >
              <AnyReactComponent
                lat={safeJsonParse(event.venue)?.latitude || 36.8065}
                lng={safeJsonParse(event.venue)?.longitude || 10.1815}
              />
            </GoogleMap>
          </div>
        </div>
      )}
    </div>
  );
}
